import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UserUpdateModalUI from './UserUpdateModalUI.js'

class UserUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // user, role
      superuserRoleId: '',
      superuserRoleList: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <UserUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // superuser role
        superuserRoleId={this.state.superuserRoleId}
        superuserRoleList={this.state.superuserRoleList}
        onSuperuserRoleIdChange={(event) => {this.setState({superuserRoleId: event.target.value})}}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getSuperuserRoles(context)
    Modal.setAppElement('body')
  }

  componentWillReceiveProps(props) {
    console.log(props.selectedUser);
    if (props.selectedUser && props.selectedUser.roleId != this.state.superuserRoleId) {
      this.setState({
        superuserRoleId : props.selectedUser.roleId,
        submitted: false,
        errorList: [],
      })
      console.log(props.selectedUser.roleId);
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/superusers/${this.props.selectedUser.userId}`,
      this.onSubmitCallback, {
        superuserRoleId: this.state.superuserRoleId,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null,
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getSuperuserRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/superuser`,
      cacheKey: CacheKeys.Roles('superuser', context.locale),
      callback: this.getSuperuserRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {locales: context.locale})
  }

  getSuperuserRolesCallback = (response) => {
    let allRoleList = response.roleList.map(role => ({key: role.roleId, value: role.roleName}))
    this.setState({
      superuserRoleList: allRoleList,
    })
  }

}

export default withRouter(UserUpdateModalSF)
